
import cms from '~/mixins/common/cms'
import gameMenu from '~/mixins/common/pages/game-menu'
import playGames from '~/mixins/common/play-games'
export default {
    name: 'GameSubmenu',
    mixins: [cms, playGames, gameMenu],
    props: {
        submenu: {
            type: Object,
            required: true,
            default: () => {},
        },
    },
}
